import React, { useContext, useState } from 'react';
import { HandlingUnit } from '../../../../../../../types/handling_unit/handlingUnit';
import { HandlingUnitContext } from '../../../../../../../context/HandlingUnitContext';
import { useToast } from '../../../../../../../providers/ToastProvider';
import {
  DeleteHandlingUnitResponse,
  DeleteHandlingUnitVariables,
  HandlingUnitMutations,
} from '../../../../../../../graphql/handlingUnit.graphql';
import useMutation from '../../../../../../../hooks/useMutation';
import { HandlingUnitInput } from '../../../../../../../types/handling_unit/handlingUnit.input';
import { ToastType } from '../../../../../../components/Toast';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { AlertModal } from '../../../../../../components/Modal';
import { Button, ButtonVariant } from '../../../../../../components/Button';

interface DeleteHandlingUnitModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  item?: HandlingUnit;
}

export default function DeleteHandlingUnitModal({ open, setOpen, item }: DeleteHandlingUnitModalProps) {
  const { showToast } = useToast();

  const { handlingUnits, setHandlingUnits } = useContext(HandlingUnitContext);

  const [input, setInput] = useState<HandlingUnitInput>(new HandlingUnitInput(item));

  const [remove, { loading }] = useMutation<DeleteHandlingUnitResponse, DeleteHandlingUnitVariables>(
    HandlingUnitMutations.remove,
    {
      variables: { handlingUnits: [input.forDelete()] },
      onCompleted: response => {
        const deletedHandlingUnit = response.deleteHandlingUnit[0];
        handlingUnits.delete(deletedHandlingUnit.id);
        setHandlingUnits(handlingUnits);
        showToast({
          type: ToastType.success,
          title: t(TranslationKey.handlingUnitDeletedSuccessfullyToastTitle).singular.upper,
        });
        setOpen(false);
      },
    },
  );

  return (
    <AlertModal open={open} setOpen={setOpen} title={t(TranslationKey.handlingUnitDelete).singular.upper}>
      <div className='body-light grid gap-4'>
        <p className='py-2'>{t(TranslationKey.handlingUnitDeleteModalPrimaryText).singular.upper}</p>

        <div className='flex items-center justify-end gap-2'>
          <Button
            text={t(TranslationKey.cancel).singular.upper}
            variant={ButtonVariant.link}
            onClick={() => setOpen(false)}
            disabled={loading}
          />
          <Button
            text={t(TranslationKey.delete).singular.upper}
            variant={ButtonVariant.danger}
            onClick={() => remove()}
            loading={loading}
          />
        </div>
      </div>
    </AlertModal>
  );
}
